{
  "version": 8,
  "name": "NLS Basemap",
  "center": [
    21.645,
    63.101
  ],
  "zoom": 11.35,
  "sources": {
    "taustakartta": {
      "type": "vector",
      "url": "https://avoin-karttakuva.maanmittauslaitos.fi/vectortiles/tilejson/taustakartta/1.0.0/taustakartta/default/v21/WGS84_Pseudo-Mercator/tilejson.json?api-key=7cd2ddae-9f2e-481c-99d0-404e7bc7a0b2"
    },
    "rasteritaustakartta": {
      "type": "raster",
      "tileSize": 256,
      "tiles": [
        "https://avoin-karttakuva.maanmittauslaitos.fi/avoin/wmts/1.0.0/ortokuva/default/WGS84_Pseudo-Mercator/{z}/{y}/{x}.png?api-key=7cd2ddae-9f2e-481c-99d0-404e7bc7a0b2"
      ]
    }
  },
  "glyphs": "https://avoin-karttakuva.maanmittauslaitos.fi/vectortiles/glyphs/{fontstack}/{range}.pbf?api-key=7cd2ddae-9f2e-481c-99d0-404e7bc7a0b2",
  "layers": [
    {
      "id": "background",
      "type": "background",
      "paint": {
        "background-color": "white"
      }
    },
    {
      "id": "taustakartta",
      "type": "raster",
      "source": "rasteritaustakartta"
    },
   
    {
      "id": "taajamaalue",
      "type": "fill",
      "source": "taustakartta",
      "source-layer": "maankaytto",
      "minzoom": 6,
      "maxzoom": 13,
      "filter": [
        "==",
        "kohdeluokka",
        40200
      ],
      "paint": {
        "fill-color": "rgba(220,199,199,0.2)"
      }
    },
    {
      "id": "vesisto_alue_reuna",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "vesisto_alue",
      "paint": {
        "line-color": "#9ec9e8",
        "line-width": 0.5
      }
    },
   
    {
      "id": "maastoaluereuna",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "maastoaluereuna",
      "filter": [
        "all",
        [
          "in",
          "kartografinenluokka",
          32200,
          32300,
          32411,
          32412,
          32413,
          32414,
          32415,
          32416,
          32417,
          32418,
          33100
        ],
        [
          "==",
          "kohdeluokka",
          30211
        ]
      ],
      "paint": {
        "line-color": "#c8c4c5",
        "line-width": 0.5
      }
    },
    {
      "id": "keinotekoinen_rantaviiva",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "maastoaluereuna",
      "filter": [
        "==",
        "kohdeluokka",
        30100
      ],
      "paint": {
        "line-color": "#c8c4c5",
        "line-width": 0.5
      }
    },
    {
      "id": "vesisto_alue",
      "type": "fill",
      "source": "taustakartta",
      "source-layer": "vesisto_alue",
      "paint": {
          "fill-color": "rgba(0,0,80,0.4)"
      }
  },

    {
      "id": "vesisto_viiva",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "vesisto_viiva",
      "paint": {
        "line-color": "#caedfb",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          0.75,
          20,
          30
        ]
      }
    },
    {
      "id": "rakennus",
      "type": "fill",
      "source": "taustakartta",
      "source-layer": "rakennus",
      "paint": {
        "fill-color": "rgba(255,255,255,0.2)",
        "fill-outline-color": "#adb0b3"
      }
    },
    {
      "id": "tiet tunnelissa",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12141,
            12132,
            12131,
            12122,
            12121,
            12112,
            12111,
            12313,
            12314,
            12136
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            -11
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-dasharray": [
          32,
          16
        ],
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          1,
          20,
          20
        ]
      }
    },
    {
      "id": "ajotie, pinnan alla",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12141
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            -1
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          1,
          20,
          20
        ]
      }
    },
    {
      "id": "ajopolku, pinnan alla",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12316
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            -1
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-dasharray": [
          12,
          2
        ],
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          1,
          20,
          20
        ]
      }
    },
    {
      "id": "polku, pinnan alla",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12313
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            -1
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-dasharray": [
          2,
          1.5
        ],
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          1,
          20,
          20
        ]
      }
    },
    {
      "id": "kavely- ja pyoratie, paallystamaton, pinnan alla",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12314
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "paallyste"
          ],
          [
            1
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            -1
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#90ca6f",
        "line-dasharray": [
          3,
          1.5
        ],
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          0.5,
          20,
          15
        ]
      }
    },
    {
      "id": "kavely- ja pyoratie, paallystetty, pinnan alla",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12314
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "paallyste"
          ],
          [
            2
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            -1
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#90ca6f",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          0.5,
          20,
          15
        ]
      }
    },
    {
      "id": "tiet_1a_1b_reuna, pinnan alla",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12111,
            12112
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            -1
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          6,
          20,
          84
        ]
      }
    },
    {
      "id": "tiet_2a_2b_reuna, pinnan alla",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12121,
            12122
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            -1
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          4,
          20,
          63
        ]
      }
    },
    {
      "id": "tiet_3a_3b_reuna, pinnan alla",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12131,
            12132
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            -1
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          3,
          20,
          30
        ]
      }
    },
    {
      "id": "rautatie_reuna, pinnan alla",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            14111,
            14110,
            14112,
            14131,
            14151,
            14152,
            14121
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            -1
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          2,
          20,
          40
        ]
      }
    },
    {
      "id": "tiet_1a_1b_taytto, pinnan alla",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12111,
            12112
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            -1
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#eeeeee",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          4,
          20,
          80
        ]
      }
    },
    {
      "id": "tiet_2a_2b_taytto, pinnan alla",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12121,
            12122
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            -1
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#eeeeee",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          2.5,
          20,
          60
        ]
      }
    },
    {
      "id": "tiet_3a_3b_taytto, pinnan alla",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12131,
            12132
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            -1
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#eeeeee",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          1.5,
          20,
          30
        ]
      }
    },
    {
      "id": "rautatie_taytto, pinnan alla",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            14111,
            14110,
            14112,
            14131,
            14151,
            14152,
            14121
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            -1
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#eeeeee",
        "line-dasharray": [
          2,
          2
        ],
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          1.5,
          20,
          30
        ]
      }
    },
    {
      "id": "ajotie, pinnalla",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12141
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            0
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          1,
          20,
          20
        ]
      }
    },
    {
      "id": "ajopolku, pinnalla",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12316
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            0
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-dasharray": [
          12,
          2
        ],
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          1,
          20,
          20
        ]
      }
    },
    {
      "id": "polku, pinnalla",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12313
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            0
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-dasharray": [
          2,
          1.5
        ],
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          1,
          20,
          20
        ]
      }
    },
    {
      "id": "kavely- ja pyoratie, paallystamaton, pinnalla",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12314
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "paallyste"
          ],
          [
            1
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            0
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#90ca6f",
        "line-dasharray": [
          3,
          1.5
        ],
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          0.5,
          20,
          15
        ]
      }
    },
    {
      "id": "kavely- ja pyoratie, paallystetty, pinnalla",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12314
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "paallyste"
          ],
          [
            2
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            0
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#90ca6f",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          0.5,
          20,
          15
        ]
      }
    },
    {
      "id": "tiet_1a_1b_reuna, pinnalla",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12111,
            12112
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            0
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          6,
          20,
          84
        ]
      }
    },
    {
      "id": "tiet_2a_2b_reuna, pinnalla",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12121,
            12122
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            0
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          4,
          20,
          63
        ]
      }
    },
    {
      "id": "tiet_3a_3b_reuna, pinnalla",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12131,
            12132
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            0
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          3,
          20,
          30
        ]
      }
    },
    {
      "id": "rautatie_reuna, pinnalla",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            14111,
            14110,
            14112,
            14131,
            14151,
            14152,
            14121
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            0
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          2,
          20,
          40
        ]
      }
    },
    {
      "id": "tiet_1a_1b_taytto, pinnalla",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12111,
            12112
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            0
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#fcfcfc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          4,
          20,
          80
        ]
      }
    },
    {
      "id": "tiet_2a_2b_taytto, pinnalla",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12121,
            12122
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            0
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#fcfcfc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          2.5,
          20,
          60
        ]
      }
    },
    {
      "id": "tiet_3a_3b_taytto, pinnalla",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12131,
            12132
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            0
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#fcfcfc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          1.5,
          20,
          30
        ]
      }
    },
    {
      "id": "rautatie_taytto, pinnalla",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            14111,
            14110,
            14112,
            14131,
            14151,
            14152,
            14121
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            0
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#fcfcfc",
        "line-dasharray": [
          2,
          2
        ],
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          1.5,
          20,
          30
        ]
      }
    },
    {
      "id": "ajotie, sillalla 1",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12141
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            1
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          1,
          20,
          20
        ]
      }
    },
    {
      "id": "ajopolku, sillalla 1",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12316
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            1
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-dasharray": [
          12,
          2
        ],
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          1,
          20,
          20
        ]
      }
    },
    {
      "id": "polku, sillalla 1",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12313
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            1
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-dasharray": [
          2,
          1.5
        ],
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          1,
          20,
          20
        ]
      }
    },
    {
      "id": "kavely- ja pyoratie, paallystamaton, sillalla 1",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12314
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "paallyste"
          ],
          [
            1
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            1
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#90ca6f",
        "line-dasharray": [
          3,
          1.5
        ],
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          0.5,
          20,
          15
        ]
      }
    },
    {
      "id": "kavely- ja pyoratie, paallystetty, sillalla 1",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12314
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "paallyste"
          ],
          [
            2
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            1
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#90ca6f",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          0.5,
          20,
          15
        ]
      }
    },
    {
      "id": "tiet_1a_1b_reuna, sillalla 1",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12111,
            12112
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            1
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          6,
          20,
          84
        ]
      }
    },
    {
      "id": "tiet_2a_2b_reuna, sillalla 1",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12121,
            12122
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            1
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          4,
          20,
          63
        ]
      }
    },
    {
      "id": "tiet_3a_3b_reuna, sillalla 1",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12131,
            12132
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            1
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          3,
          20,
          30
        ]
      }
    },
    {
      "id": "rautatie_reuna, sillalla 1",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            14111,
            14110,
            14112,
            14131,
            14151,
            14152,
            14121
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            1
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          2,
          20,
          40
        ]
      }
    },
    {
      "id": "tiet_1a_1b_taytto, sillalla 1",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12111,
            12112
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            1
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#fcfcfc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          4,
          20,
          80
        ]
      }
    },
    {
      "id": "tiet_2a_2b_taytto, sillalla 1",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12121,
            12122
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            1
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#fcfcfc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          2.5,
          20,
          60
        ]
      }
    },
    {
      "id": "tiet_3a_3b_taytto, sillalla 1",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12131,
            12132
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            1
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#eeeeee",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          1.5,
          20,
          30
        ]
      }
    },
    {
      "id": "rautatie_taytto, sillalla 1",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            14111,
            14110,
            14112,
            14131,
            14151,
            14152,
            14121
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            1
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#fcfcfc",
        "line-dasharray": [
          2,
          2
        ],
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          1.5,
          20,
          30
        ]
      }
    },
    {
      "id": "ajotie, sillalla 2",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12141
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            2
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          1,
          20,
          20
        ]
      }
    },
    {
      "id": "ajopolku, sillalla 2",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12316
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            2
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-dasharray": [
          12,
          2
        ],
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          1,
          20,
          20
        ]
      }
    },
    {
      "id": "polku, sillalla 2",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12313
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            2
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-dasharray": [
          2,
          1.5
        ],
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          1,
          20,
          20
        ]
      }
    },
    {
      "id": "kavely- ja pyoratie, paallystamaton, sillalla 2",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12314
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "paallyste"
          ],
          [
            1
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            2
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#90ca6f",
        "line-dasharray": [
          3,
          1.5
        ],
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          0.5,
          20,
          15
        ]
      }
    },
    {
      "id": "kavely- ja pyoratie, paallystetty, sillalla 2",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12314
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "paallyste"
          ],
          [
            2
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            2
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#90ca6f",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          0.5,
          20,
          15
        ]
      }
    },
    {
      "id": "tiet_1a_1b_reuna, sillalla 2",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12111,
            12112
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            2
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          6,
          20,
          84
        ]
      }
    },
    {
      "id": "tiet_2a_2b_reuna, sillalla 2",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12121,
            12122
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            2
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          4,
          20,
          63
        ]
      }
    },
    {
      "id": "tiet_3a_3b_reuna, sillalla 2",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12131,
            12132
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            2
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          3,
          20,
          30
        ]
      }
    },
    {
      "id": "rautatie_reuna, sillalla 2",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            14111,
            14110,
            14112,
            14131,
            14151,
            14152,
            14121
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            2
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          2,
          20,
          40
        ]
      }
    },
    {
      "id": "tiet_1a_1b_taytto, sillalla 2",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12111,
            12112
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            2
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#fcfcfc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          4,
          20,
          80
        ]
      }
    },
    {
      "id": "tiet_2a_2b_taytto, sillalla 2",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12121,
            12122
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            2
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#fcfcfc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          2.5,
          20,
          60
        ]
      }
    },
    {
      "id": "tiet_3a_3b_taytto, sillalla 2",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12131,
            12132
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            2
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#fcfcfc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          1.5,
          20,
          30
        ]
      }
    },
    {
      "id": "rautatie_taytto, sillalla 2",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            14111,
            14110,
            14112,
            14131,
            14151,
            14152,
            14121
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            2
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#fcfcfc",
        "line-dasharray": [
          2,
          2
        ],
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          1.5,
          20,
          30
        ]
      }
    },
    {
      "id": "ajotie, sillalla 3",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12141
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            3
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          1,
          20,
          20
        ]
      }
    },
    {
      "id": "ajopolku, sillalla 3",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12316
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            3
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-dasharray": [
          12,
          2
        ],
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          1,
          20,
          20
        ]
      }
    },
    {
      "id": "polku, sillalla 3",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12313
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            3
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-dasharray": [
          2,
          1.5
        ],
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          1,
          20,
          20
        ]
      }
    },
    {
      "id": "kavely- ja pyoratie, paallystamaton, sillalla 3",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12314
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "paallyste"
          ],
          [
            1
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            3
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#90ca6f",
        "line-dasharray": [
          3,
          1.5
        ],
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          0.5,
          20,
          15
        ]
      }
    },
    {
      "id": "kavely- ja pyoratie, paallystetty, sillalla 3",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12314
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "paallyste"
          ],
          [
            2
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            3
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#90ca6f",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          0.5,
          20,
          15
        ]
      }
    },
    {
      "id": "tiet_1a_1b_reuna, sillalla 3",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12111,
            12112
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            3
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          6,
          20,
          84
        ]
      }
    },
    {
      "id": "tiet_2a_2b_reuna, sillalla 3",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12121,
            12122
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            3
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          4,
          20,
          63
        ]
      }
    },
    {
      "id": "tiet_3a_3b_reuna, sillalla 3",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12131,
            12132
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            3
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          3,
          20,
          30
        ]
      }
    },
    {
      "id": "rautatie_reuna, sillalla 3",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            14111,
            14110,
            14112,
            14131,
            14151,
            14152,
            14121
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            3
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          2,
          20,
          40
        ]
      }
    },
    {
      "id": "tiet_1a_1b_taytto, sillalla 3",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12111,
            12112
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            3
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#fcfcfc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          4,
          20,
          80
        ]
      }
    },
    {
      "id": "tiet_2a_2b_taytto, sillalla 3",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12121,
            12122
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            3
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#fcfcfc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          2.5,
          20,
          60
        ]
      }
    },
    {
      "id": "tiet_3a_3b_taytto, sillalla 3",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12131,
            12132
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            3
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#fcfcfc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          1.5,
          20,
          30
        ]
      }
    },
    {
      "id": "rautatie_taytto, sillalla 3",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            14111,
            14110,
            14112,
            14131,
            14151,
            14152,
            14121
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            3
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#fcfcfc",
        "line-dasharray": [
          2,
          2
        ],
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          1.5,
          20,
          30
        ]
      }
    },
    {
      "id": "ajotie, sillalla 4",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12141
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            4
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          1,
          20,
          20
        ]
      }
    },
    {
      "id": "ajopolku, sillalla 4",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12316
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            4
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-dasharray": [
          12,
          2
        ],
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          1,
          20,
          20
        ]
      }
    },
    {
      "id": "polku, sillalla 4",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12313
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            4
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-dasharray": [
          2,
          1.5
        ],
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          1,
          20,
          20
        ]
      }
    },
    {
      "id": "kavely- ja pyoratie, paallystamaton, sillalla 4",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12314
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "paallyste"
          ],
          [
            1
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            4
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#90ca6f",
        "line-dasharray": [
          3,
          1.5
        ],
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          0.5,
          20,
          15
        ]
      }
    },
    {
      "id": "kavely- ja pyoratie, paallystetty, sillalla 4",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12314
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "paallyste"
          ],
          [
            2
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            4
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#90ca6f",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          0.5,
          20,
          15
        ]
      }
    },
    {
      "id": "tiet_1a_1b_reuna, sillalla 4",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12111,
            12112
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            4
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          6,
          20,
          84
        ]
      }
    },
    {
      "id": "tiet_2a_2b_reuna, sillalla 4",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12121,
            12122
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            4
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          4,
          20,
          63
        ]
      }
    },
    {
      "id": "tiet_3a_3b_reuna, sillalla 4",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12131,
            12132
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            4
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          3,
          20,
          30
        ]
      }
    },
    {
      "id": "rautatie_reuna, sillalla 4",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            14111,
            14110,
            14112,
            14131,
            14151,
            14152,
            14121
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            4
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          2,
          20,
          40
        ]
      }
    },
    {
      "id": "tiet_1a_1b_taytto, sillalla 4",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12111,
            12112
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            4
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#fcfcfc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          4,
          20,
          80
        ]
      }
    },
    {
      "id": "tiet_2a_2b_taytto, sillalla 4",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12121,
            12122
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            4
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#fcfcfc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          2.5,
          20,
          60
        ]
      }
    },
    {
      "id": "tiet_3a_3b_taytto, sillalla 4",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12131,
            12132
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            4
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#fcfcfc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          1.5,
          20,
          30
        ]
      }
    },
    {
      "id": "rautatie_taytto, sillalla 4",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            14111,
            14110,
            14112,
            14131,
            14151,
            14152,
            14121
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            4
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#fcfcfc",
        "line-dasharray": [
          2,
          2
        ],
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          1.5,
          20,
          30
        ]
      }
    },
    {
      "id": "ajotie, sillalla 5",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12141
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            5
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          1,
          20,
          20
        ]
      }
    },
    {
      "id": "ajopolku, sillalla 5",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12316
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            5
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-dasharray": [
          12,
          2
        ],
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          1,
          20,
          20
        ]
      }
    },
    {
      "id": "polku, sillalla 5",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12313
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            5
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-dasharray": [
          2,
          1.5
        ],
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          1,
          20,
          20
        ]
      }
    },
    {
      "id": "kavely- ja pyoratie, paallystamaton, sillalla 5",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12314
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "paallyste"
          ],
          [
            1
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            5
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#90ca6f",
        "line-dasharray": [
          3,
          1.5
        ],
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          0.5,
          20,
          15
        ]
      }
    },
    {
      "id": "kavely- ja pyoratie, paallystetty, sillalla 5",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12314
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "paallyste"
          ],
          [
            2
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            5
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#90ca6f",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          0.5,
          20,
          15
        ]
      }
    },
    {
      "id": "tiet_1a_1b_reuna, sillalla 5",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12111,
            12112
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            5
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          6,
          20,
          84
        ]
      }
    },
    {
      "id": "tiet_2a_2b_reuna, sillalla 5",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12121,
            12122
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            5
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          4,
          20,
          63
        ]
      }
    },
    {
      "id": "tiet_3a_3b_reuna, sillalla 5",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12131,
            12132
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            5
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          3,
          20,
          30
        ]
      }
    },
    {
      "id": "rautatie_reuna, sillalla 5",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            14111,
            14110,
            14112,
            14131,
            14151,
            14152,
            14121
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            5
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          2,
          20,
          40
        ]
      }
    },
    {
      "id": "tiet_1a_1b_taytto, sillalla 5",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12111,
            12112
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            5
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#fcfcfc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          4,
          20,
          80
        ]
      }
    },
    {
      "id": "tiet_2a_2b_taytto, sillalla 5",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12121,
            12122
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            5
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#fcfcfc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          2.5,
          20,
          60
        ]
      }
    },
    {
      "id": "tiet_3a_3b_taytto, sillalla 5",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12131,
            12132
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            5
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#fcfcfc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          1.5,
          20,
          30
        ]
      }
    },
    {
      "id": "rautatie_taytto, sillalla 5",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            14111,
            14110,
            14112,
            14131,
            14151,
            14152,
            14121
          ],
          true,
          false
        ],
        [
          "match",
          [
            "get",
            "tasosijainti"
          ],
          [
            5
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#fcfcfc",
        "line-dasharray": [
          2,
          2
        ],
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          1.5,
          20,
          30
        ]
      }
    },
    {
      "id": "lautta ja lossi",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12151,
            12152
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-dasharray": [
          6,
          8
        ],
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          1.5,
          20,
          30
        ]
      }
    },
    {
      "id": "laiva ja venevaylat",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            16511,
            16512
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-dasharray": [
          6,
          8
        ],
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          1,
          20,
          20
        ]
      }
    },
    {
      "id": "hallintorajat",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "hallintoalue",
      "paint": {
        "line-color": "#8668de",
        "line-width": 1,
        "line-opacity": 0.5
      }
    },
    {
      "id": "rakennelmat",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "rakennelma",
      "filter": [
        "any",
        [
          "==",
          "kohdeluokka",
          45700
        ],
        [
          "==",
          "kohdeluokka",
          45111
        ],
        [
          "==",
          "kohdeluokka",
          45112
        ],
        [
          "==",
          "kohdeluokka",
          44500
        ]
      ],
      "paint": {
        "line-color": "#918a8c",
        "line-width": 0.5
      }
    },
    {
      "id": "tienimet",
      "type": "symbol",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "<",
          "tasosijainti",
          1
        ]
      ],
      "layout": {
        "text-field": "{nimi_suomi}        {nimi_ruotsi}",
        "text-font": [
          "Liberation Sans NLSFI"
        ],
        "symbol-placement": "line",
        "text-size": 11
      },
      "paint": {
        "text-color": "rgba(69, 86, 71, 1)",
        "text-halo-color": "#fff",
        "text-halo-width": 1,
        "text-halo-blur": 1
      }
    },
    {
      "id": "nimisto-maasto-vedet",
      "type": "symbol",
      "source": "taustakartta",
      "source-layer": "nimisto",
      "filter": [
        "match",
        [
          "get",
          "teema"
        ],
        [
          "Maasto",
          "Vedet"
        ],
        true,
        false
      ],
      "layout": {
        "text-field": [
          "coalesce",
          [
            "get",
            "nimi_fin"
          ],
          [
            "get",
            "nimi_swe"
          ],
          [
            "get",
            "nimi_sme"
          ],
          [
            "get",
            "nimi_sms"
          ],
          [
            "get",
            "nimi_smn"
          ]
        ],
        "text-font": [
          "match",
          [
            "get",
            "teema"
          ],
          "Vedet",
          [
            "literal",
            [
              "Liberation Sans NLSFI Left"
            ]
          ],
          "Maasto",
          [
            "literal",
            [
              "Liberation Sans NLSFI Right"
            ]
          ],
          [
            "literal",
            [
              "Liberation Sans NLSFI"
            ]
          ]
        ],
        "text-size": [
          "interpolate",
          [
            "linear"
          ],
          [
            "zoom"
          ],
          1,
          [
            "step",
            [
              "get",
              "prioriteetti"
            ],
            20,
            3,
            16
          ],
          10,
          [
            "step",
            [
              "get",
              "prioriteetti"
            ],
            20,
            4,
            14
          ],
          16,
          [
            "step",
            [
              "get",
              "prioriteetti"
            ],
            22,
            5,
            12
          ]
        ],
        "visibility": "visible"
      },
      "paint": {
        "text-halo-width": 2,
        "text-halo-color": "rgba(255, 255, 255, 1)",
        "text-color": [
          "match",
          [
            "get",
            "teema"
          ],
          "Vedet",
          "hsl(251, 71%, 50%)",
          "hsl(0, 0%, 20%)"
        ],
        "text-halo-blur": 1
      }
    },
    {
      "id": "nimisto",
      "type": "symbol",
      "source": "taustakartta",
      "source-layer": "nimisto",
      "filter": [
        "all",
        [
          "!",
          [
            "match",
            [
              "get",
              "teema"
            ],
            [
              "Maasto",
              "Vedet"
            ],
            true,
            false
          ]
        ],
        [
          "!=",
          [
            "get",
            "alaryhma"
          ],
          "Hallintoalueet"
        ],
        [
          "match",
          [
            "get",
            "laji"
          ],
          [
            "Kansallispuisto",
            "Luonnonpuisto"
          ],
          false,
          true
        ]
      ],
      "layout": {
        "text-transform": [
          "match",
          [
            "get",
            "alaryhma"
          ],
          "Rautatieliikennepaikat",
          "uppercase",
          "none"
        ],
        "text-field": [
          "coalesce",
          [
            "get",
            "nimi_fin"
          ],
          [
            "get",
            "nimi_swe"
          ],
          [
            "get",
            "nimi_sme"
          ],
          [
            "get",
            "nimi_sms"
          ],
          [
            "get",
            "nimi_smn"
          ]
        ],
        "icon-ignore-placement": true,
        "icon-allow-overlap": true,
        "text-font": [
          "Liberation Sans NLSFI"
        ],
        "text-size": [
          "interpolate",
          [
            "linear"
          ],
          [
            "zoom"
          ],
          1,
          [
            "interpolate",
            [
              "linear"
            ],
            [
              "get",
              "prioriteetti"
            ],
            1,
            20,
            3,
            16
          ],
          10,
          [
            "interpolate",
            [
              "linear"
            ],
            [
              "get",
              "prioriteetti"
            ],
            5,
            16,
            7,
            13
          ],
          14,
          [
            "interpolate",
            [
              "linear"
            ],
            [
              "get",
              "prioriteetti"
            ],
            5,
            22,
            10,
            12
          ]
        ],
        "visibility": "visible"
      },
      "paint": {
        "text-halo-width": 2,
        "text-halo-color": "rgba(255, 255, 255, 1)",
        "text-color": [
          "match",
          [
            "get",
            "teema"
          ],
          "Vedet",
          "hsl(251, 71%, 50%)",
          "Suojellut kohteet",
          "hsl(117, 79%, 31%)",
          "hsl(0, 0%, 15%)"
        ],
        "text-halo-blur": 1
      }
    },
    {
      "id": "nimisto_luonnopuistot",
      "type": "symbol",
      "source": "taustakartta",
      "source-layer": "nimisto",
      "filter": [
        "match",
        [
          "get",
          "laji"
        ],
        [
          "Kansallispuisto",
          "Luonnonpuisto"
        ],
        true,
        false
      ],
      "layout": {
        "text-field": [
          "coalesce",
          [
            "get",
            "nimi_fin"
          ],
          [
            "get",
            "nimi_swe"
          ],
          [
            "get",
            "nimi_sme"
          ],
          [
            "get",
            "nimi_sms"
          ],
          [
            "get",
            "nimi_smn"
          ]
        ],
        "icon-ignore-placement": true,
        "icon-allow-overlap": false,
        "text-font": [
          "Liberation Sans NLSFI"
        ],
        "visibility": "visible"
      },
      "paint": {
        "text-halo-width": 2,
        "text-halo-color": "rgba(255, 255, 255, 1)",
        "text-color": "hsl(117, 79%, 31%)",
        "text-halo-blur": 1
      }
    },
    {
      "id": "nimisto_kunnat",
      "type": "symbol",
      "source": "taustakartta",
      "source-layer": "nimisto",
      "filter": [
        "all",
        [
          "==",
          [
            "get",
            "alaryhma"
          ],
          "Hallintoalueet"
        ],
        [
          "==",
          [
            "get",
            "laji"
          ],
          "Kunta"
        ]
      ],
      "layout": {
        "text-field": [
          "coalesce",
          [
            "get",
            "nimi_fin"
          ],
          [
            "get",
            "nimi_swe"
          ],
          [
            "get",
            "nimi_sme"
          ],
          [
            "get",
            "nimi_sms"
          ],
          [
            "get",
            "nimi_smn"
          ]
        ],
        "icon-ignore-placement": false,
        "icon-allow-overlap": false,
        "text-size": [
          "interpolate",
          [
            "exponential",
            1.35
          ],
          [
            "zoom"
          ],
          1,
          16,
          14,
          28
        ],
        "text-font": [
          "step",
          [
            "zoom"
          ],
          [
            "literal",
            [
              "Liberation Sans NLSFI"
            ]
          ],
          6,
          [
            "literal",
            [
              "Liberation Sans NLSFI Bold"
            ]
          ]
        ]
      },
      "paint": {
        "text-halo-width": 2,
        "text-halo-color": "rgb(255, 255, 255)",
        "text-color": "hsl(0, 0%, 25%)",
        "text-halo-blur": 1
      }
    }
  ],
  "id": "NLS-Basemap"
}